const pluralWordPure = (val, w0, w1, w2) => {
  if (/1\d$/.test(val)) {
    return w2;
  }

  if (/1$/.test(val)) {
    return w0;
  }

  if (/[234]$/.test(val)) {
    return w1;
  }

  return w2;
};

const pluralWord = (val, w0, w1, w2, separator = ' ') => {
  const word = pluralWordPure(val, w0, w1, w2);
  return val + separator + word;
};

export const fixShortMonth = (str) => str
  .replace('янв.', 'янв')
  .replace('февр.', 'фев')
  .replace('марта', 'мар')
  .replace('мар.', 'мар')
  .replace('март', 'мар')
  .replace('апр.', 'апр')
  .replace('мая', 'мая')
  .replace('июн.', 'июн')
  .replace('июня', 'июн')
  .replace('июл.', 'июл')
  .replace('июнь', 'июн')
  .replace('июня', 'июн')
  .replace('июль', 'июл')
  .replace('июля', 'июл')
  .replace('авг.', 'авг')
  .replace('сент.', 'сен')
  .replace('окт.', 'окт')
  .replace('нояб.', 'ноя')
  .replace('дек.', 'дек');

const convertDateToString = (date, monthFormat = 'long', withTime = false, withYear = true) => {
  if (!date) {
    return '';
  }

  const params = {
    month: monthFormat,
    day: 'numeric',
  };

  if (withYear) {
    params.year = 'numeric';
  }

  if (withTime) {
    params.hour = 'numeric';
    params.minute = 'numeric';
  }

  let dateStr = date.toLocaleString('ru', params);

  if (monthFormat === 'short') {
    dateStr = fixShortMonth(dateStr);
  }

  return dateStr.replace(' г., ', ' в ').replace(' г.', '').replace(', ', ' в ');
};

// eslint-disable-next-line
const getUserName = (user) => {
  return user.name
    ? `${user.name} ${user.surname}`
    : user.email;
};

const storageSizeCounter = (size) => {
  const memoryNames = ['б', 'кб', 'мб', 'гб', 'тб'];
  let memoryNamesIndex = 0;
  const sizeCounter = {
    memorySize: size,
    memoryName: memoryNames[memoryNamesIndex],
  };
  while (sizeCounter.memorySize > 1024 && memoryNamesIndex < 5) {
    sizeCounter.memorySize /= 1024;
    memoryNamesIndex += 1;
    sizeCounter.memoryName = memoryNames[memoryNamesIndex];
  }
  return `${Math.round(sizeCounter.memorySize)} ${sizeCounter.memoryName}`;
};

const downloadFile = (fileData) => {
  const link = document.createElement('a');

  link.setAttribute('download', fileData.file.name);
  link.href = fileData.file.url;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const fileSize = (size, tail = 1000, extDivider) => {
  let unit = 'ГБ';
  let divider = 1024 * 1024 * 1024;

  if (size < 1024) {
    unit = 'Б';
    divider = 1;
  } else if (size < 1024 * 1024) {
    unit = 'КБ';
    divider = 1024;
  } else if (size < 1024 * 1024 * 1024) {
    unit = 'МБ';
    divider = 1024 * 1024;
  }

  // eslint-disable-next-line no-param-reassign
  extDivider ??= divider;

  const value = Math.round((size * tail) / extDivider) / tail;

  return {
    unit,
    value,
    string: `${value} ${unit}`,
  };
};

export function getWeekNumber(ref) {
  // Copy date so don't modify original
  const d = new Date(Date.UTC(ref.getFullYear(), ref.getMonth(), ref.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

const haveIntersection = (data, target) => {
  const setA = data.size < target.size ? target : data;
  const setB = data.size < target.size ? data : target;

  let result = false;
  setB.forEach((value) => {
    if (setA.has(value)) {
      result = true;
    }
  });

  return result;
};

function debounce(callback, delay) {
  let timeout;

  function deferred() {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(this, arguments), delay); // eslint-disable-line
  }

  function immediate() {
    clearTimeout(timeout);
    callback.apply(this, arguments); // eslint-disable-line
  }

  return { deferred, immediate };
}

export default {
  pluralWord,
  pluralWordPure,
  convertDateToString,
  getUserName,
  storageSizeCounter,
  downloadFile,
  fileSize,
  haveIntersection,
  debounce,
};
